module.exports = __webpack_public_path__ + "img/consumption.c0f74b99.svg";